import React from "react";
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <nav>
                <ul>
                    <div className="footer-sep">
                        <div className="footer-sep-social">
                            <li>
                                <a href="https://github.com/rzinak" target="_blank">github</a>
                                <a href="https://wakatime.com/@rzin" target="_blank">wakatime</a>

                            </li>
                        </div>
                        <div>
                            <a href="https://nick-black.com/dankwiki/images/a/ad/Dijkstra.jpg?20250306182234" target="_blank" rel="noopener noreferrer"><span>λx.x</span></a>
                        </div>
                    </div>
                </ul>
            </nav>
        </div>
    )
}

export default Footer;
